import Decision from './Decision';

export default Decision;
